namespace JupitersChoice {
    export class ResetReelsCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('GameConfig') _config: Sapphire.GameConfig;
        @inject('GameServer') _gameServer: Sapphire.GameServer;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const reels = this._componentManager.get('Reels');

            // if we have previous login response which includes a stops array, set the reels to those stops
            // otherwise fall back to initial defined reel stops (show on game load)
            if (response && response.stops && response.stops.length > 0) {
                reels.stop(response.stops, [0, 0, 0, 0, 0], null, true);
            } else {
                reels.stop([37, 21, 34, 48, 13, 13], [0, 0, 0, 0, 0], null, true);
            }

        }
    }
}